'use strict';

var _vanillaMasker = require('vanilla-masker');

var _vanillaMasker2 = _interopRequireDefault(_vanillaMasker);

require('./form-donation.scss');

var _axios = require('axios');

var _axios2 = _interopRequireDefault(_axios);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

$$('.ll-form-donation').each(function () {
	var $form = $$(this),
	    $donation = $form.find('.ll-input-donation'),
	    $tabs = $form.find('.ll-form-donation__tab'),
	    $pessoa = $form.find('#donation-pessoa'),
	    $email = $form.find('#donation-email'),
	    $cpf = $form.find('#donation-cpf'),
	    $empresa = $form.find('#donation-empresa'),
	    $cnpj = $form.find('#donation-cnpj'),
	    $type = $form.find('#donation-type'),
	    $submit = $form.find('#donation-submit'),
	    $hidden = $form.find('.ll-input-donation__hidden'),
	    $total = $form.find('.ll-form-donation__total'),
	    $payment = $form.find('.ll-input-payment'),
	    monthly = false;

	var validate = function validate(update) {
		var type = $type.val(),
		    valid = false;

		switch (type) {
			case 'pessoa-fisica':
				valid = $pessoa[0].validate(update) && $cpf[0].validate(update) && $email[0].validate(update);
				break;
			case 'pessoa-juridica':
				valid = $empresa[0].validate(update) && $cnpj[0].validate(update) && $email[0].validate(update);
				break;
			default:
				break;
		}

		if ($hidden.val() == '' || $hidden.val() == 0) valid = false;

		if (!$donation[0].validate()) valid = false;

		if (!$email[0].validate()) valid = false;

		// Toggle submit button disabled
		// $submit.prop('disabled', !valid)

		return valid;
	};

	$pessoa.on('keyup', function (event) {
		return validate();
	});
	$cpf.on('keyup', function (event) {
		return validate();
	});
	$empresa.on('keyup', function (event) {
		return validate();
	});
	$cnpj.on('keyup', function (event) {
		return validate();
	});
	$email.on('keyup', function (event) {
		return validate();
	});

	$tabs.each(function () {
		var $tab = $$(this);

		$tab.on('click', function (event) {
			var $target = $$($tab.data('target')),
			    $contents = $form.find('.ll-tab-content');

			// Toggle tab active class
			$tabs.removeClass('is-active');
			$tab.addClass('is-active');

			// Show/hide tab content
			$contents.hide();
			$target.show();

			// Toggle type
			if ($type.val() == 'pessoa-fisica') $type.val('pessoa-juridica');else $type.val('pessoa-fisica');

			// Then validate
			validate();

			// Prevent form submition
			event.preventDefault();
		});
	});

	var onFormSubmit = function onFormSubmit(event) {
		if (!validate(true)) return event.preventDefault();

		var btn = $payment.find('.is-active').val();
		var freq = $form.find('input[name="donation_type"]').val();

		$submit.prop('disabled', true);
		if (btn == 'pagseguro') {
			if (freq == 'monthly') $form.prop('action', process.env.PAGSEGURO_PLAN);
			if (freq == 'one') $form.prop('action', process.env.PAGSEGURO_CHECKOUT);
		} else {
			if (freq == 'monthly') $form.prop('action', process.env.PAYPAL_PLAN);
			if (freq == 'one') $form.prop('action', process.env.PAYPAL_CHECKOUT);
		}
		(0, _axios2.default)({
			method: 'post',
			url: '/donate',
			// url: `http://658eeb32.ngrok.io/donate`,
			data: {
				'donation-pessoa': $pessoa[0].val(),
				'donation-cpf': $cpf[0].val(),
				'donation-empresa': $empresa[0].val(),
				'donation-cnpj': $cnpj[0].val(),
				'donation-email': $email[0].val(),
				'type': $type.val(),
				'value': $hidden.val(),
				'monthly': monthly,
				'payment_gateway': btn
			},
			responseType: 'json',
			headers: {
				'X-CSRF-TOKEN': $$('meta[name="csrf-token"]').attr('content')
			}
		}).then(function (response) {
			if (response.status == 200) {
				var donation = response.data.donation;
				$form.find('input[name="ref_transacao"]').val(donation.id);
				$form.find('input[name="reference"]').val(donation.id);
				$form.off('submit', onFormSubmit);
				$form.submit();
			}
		}).catch(function (error) {
			$submit.prop('disabled', false);
			console.error(error);
		});

		event.preventDefault();
	};

	$form.on('submit', onFormSubmit);

	// On true value change
	$hidden.on('change', function (event) {
		var value = _vanillaMasker2.default.toMoney(event.detail, {
			zeroCents: true
		});

		// Change form total value
		$total.find('span:nth-child(1)').html(value);

		// Change pagseguro product value
		$form.find('input[name="itemAmount1"]').val(event.detail * 100);

		validate();
	});

	// On monthly checkbox change
	$donation.on('monthly-change', function (event) {
		var value = $hidden.val();
		monthly = event.detail;

		if (value != 50 && value != 80 && value != 100 && value != 200 && value != 500 && value != 1000) {
			$total.find('span:nth-child(1)').html('0,00');
			$hidden.val('');
		}

		if (monthly) {
			$form.find('input[name="donation_type"]').val('monthly');
		} else {
			$form.find('input[name="donation_type"]').val('one');
		}

		validate();
	});

	$donation.on('code-change', function (event) {
		var code = event.detail;

		$form.find('input[name="code"]').val(code);
	});

	// Set CSRF token
	$form.find('input[name="_token"]').val($$('meta[name="csrf-token"]').attr('content'));

	// Set initial form action

	$form.prop('action', process.env.PAGSEGURO_CHECKOUT);
});


//////////////////
// WEBPACK FOOTER
// ./src/components/form/form-donation.js
// module id = 55
// module chunks = 0